import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { hmsWorkflowSteps } from "../hmsModulesData";
import HmsIcon from "../hmsIcons";
import hospitalBanner from "../../../images/products/hospital-management-system.png";

const HmsHowItWorksSection: React.FC = () => {
  return (
    <section className="hms-how" aria-labelledby="hms-how-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="hms-how-title" className="wdev-section-head__title wdev-section-head__title--dark">
            How Automated Hospital Management System Works?
          </h2>
        </AnimatedSection>

        <AnimatedSection className="hms-how__banner-wrap" delay={0.1}>
          <img
            src={hospitalBanner}
            alt="Automated Hospital Management System — Doctor, Patients, Nurses, Laboratorists, Pharmacists, Receptionists and Accountant modules"
            className="hms-how__banner"
            loading="lazy"
          />
        </AnimatedSection>

        <ol className="hms-how__steps">
          {hmsWorkflowSteps.map((step, index) => (
            <motion.li
              key={step.title}
              className="hms-how__step"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.07 }}
            >
              <span className="hms-how__step-icon">
                <HmsIcon name={step.icon} />
              </span>
              <div>
                <span className="hms-how__step-num" aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <h3 className="hms-how__step-title">{step.title}</h3>
                <p className="hms-how__step-text">{step.text}</p>
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HmsHowItWorksSection;
